import type { LinearTransformPlaygroundParams } from './linear-transform-playground.component';

/**
 * Structured presets for the LinearTransformPlaygroundComponent.
 *
 * Each preset is a {@link LinearTransformPlaygroundParams} object.
 * These are the **single source of truth** -- both Storybook stories
 * and the lesson JSON import/reference these presets.
 */

// -- Base (identity transform) ------------------------------------------

export const LINEAR_TRANSFORM_DEFAULT: LinearTransformPlaygroundParams = {
  muX: 5,
  sigmaX: 1.5,
  initialA: 1,
  initialB: 0,
};

// -- Double and shift (Y = 2X + 3) -------------------------------------

export const LINEAR_TRANSFORM_DOUBLE_SHIFT: LinearTransformPlaygroundParams = {
  muX: 5,
  sigmaX: 1.5,
  initialA: 2,
  initialB: 3,
};

// -- Negative scale (Y = -1X + 10) -------------------------------------

export const LINEAR_TRANSFORM_NEGATIVE_SCALE: LinearTransformPlaygroundParams = {
  muX: 5,
  sigmaX: 1.5,
  initialA: -1,
  initialB: 10,
};

// -- Celsius to Fahrenheit (Y = 1.8X + 32) -----------------------------

export const LINEAR_TRANSFORM_CELSIUS_TO_FAHRENHEIT: LinearTransformPlaygroundParams = {
  muX: 20,
  sigmaX: 5,
  initialA: 1.8,
  initialB: 32,
};

// -- Small spread -------------------------------------------------------

export const LINEAR_TRANSFORM_SMALL_SPREAD: LinearTransformPlaygroundParams = {
  muX: 100,
  sigmaX: 2,
  initialA: 0.5,
  initialB: -10,
};

// -- Preset registry ----------------------------------------------------

export const LINEAR_TRANSFORM_PLAYGROUND_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: LINEAR_TRANSFORM_DEFAULT },
  'double-shift': { params: LINEAR_TRANSFORM_DOUBLE_SHIFT },
  'negative-scale': { params: LINEAR_TRANSFORM_NEGATIVE_SCALE },
  'celsius-to-fahrenheit': { params: LINEAR_TRANSFORM_CELSIUS_TO_FAHRENHEIT },
  'small-spread': { params: LINEAR_TRANSFORM_SMALL_SPREAD },
};
